import Axios from 'axios';
import { getHeaders } from '../../utills';
import Apis from '../Apis';
import StoreAction from '../Actions/StoreAction';
import GeneralAction from '../Actions/GeneralAction';
import CheckListActions from '../Actions/CheckListActions';
import AlertAction from '../Actions/AlertActions';

class ChecklistMiddleware {


    static getChecklist = (userData) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    if (userData?.next_page_url == undefined) {
                        dispatch(CheckListActions.clearCheckList())
                    }
                    const { data } = await Axios.get(
                        Apis.checklist(userData?.next_page_url),
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        dispatch(CheckListActions.getCheckList(data?.data))
                        dispatch(GeneralAction.HideLoading());
                    } else {
                        dispatch(GeneralAction.HideLoading());
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                    console.log(error);
                    dispatch(GeneralAction.HideLoading());
                }
            });
        };
    };

    static sendChecklist = (userData) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.get(
                        Apis.sendChecklist + `${userData?.id}`,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        resolve(data)
                        dispatch(ChecklistMiddleware.getChecklist(userData))
                        dispatch(GeneralAction.HideLoading())
                    } else {
                        dispatch(GeneralAction.HideLoading())
                        dispatch(AlertAction.ShowAlert({ type: "error", message: data?.message }))
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                    console.log(error);
                    dispatch(GeneralAction.HideLoading())
                }
            });
        };
    };

    // static getChecklistReports = (userData) => {
    //     return dispatch => {
    //         dispatch(GeneralAction.ShowLoading());
    //         return new Promise(async (resolve, reject) => {
    //             try {
    //                 if (userData?.next_page_url == undefined) {
    //                     dispatch(CheckListActions.clearCheckReportList())
    //                 }
    //                 const { data } = await Axios.post(
    //                     Apis.checklistReports(userData?.next_page_url),
    //                     {},
    // //                     {
    //                         headers: getHeaders()
    //                     }
    //                 );
    //                 if (data?.success) {
    //                     // resolve(data)
    //                     dispatch(CheckListActions.getCheckReportList(data?.data))
    //                     dispatch(GeneralAction.HideLoading());
    //                 } else {
    //                     dispatch(GeneralAction.HideLoading());
    //                 }
    //             } catch (error) {
    //                 reject(error);
    //                 dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
    //                 console.log(error);
    //                 dispatch(GeneralAction.HideLoading());
    //             }
    //         });
    //     };
    // };


    static getChecklistReports = (userData) => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading())
            return new Promise(async (resolve, reject) => {
                try {
                    if (userData?.location_id || userData?.date_from || userData?.date_to || userData?.next_page_url == undefined) {
                        if (userData?.location_id && userData?.date_from && userData?.date_to && userData?.next_page_url) {
                        }
                        else {
                            dispatch(CheckListActions.clearCheckReportList())
                        }
                    }
                    let formdata = new FormData()
                    formdata.append('location_id', userData?.location_id);
                    formdata.append('date_from', userData?.date_from);
                    formdata.append('date_to', userData?.date_to);
                    const { data } = await Axios.post(
                        Apis.checklistReports(userData?.next_page_url),
                        formdata,
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        dispatch(CheckListActions.getCheckReportList(data?.data))
                        dispatch(GeneralAction.HideLoading())
                    } else {
                        dispatch(GeneralAction.HideLoading())
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                    console.log(error);
                    dispatch(GeneralAction.HideLoading())
                }
            });
        };
    };


    static getLocations = () => {
        return dispatch => {
            dispatch(GeneralAction.ShowLoading());
            return new Promise(async (resolve, reject) => {
                try {
                    const { data } = await Axios.post(
                        Apis.completedJobsLocations,
                        {},
                        {
                            headers: getHeaders()
                        }
                    );
                    if (data?.success) {
                        resolve(data)
                        dispatch(GeneralAction.HideLoading());
                    } else {
                        dispatch(GeneralAction.HideLoading());
                    }
                } catch (error) {
                    reject(error);
                    dispatch(AlertAction.ShowAlert({ type: "error", message: 'Network error' }))
                    console.log(error);
                    dispatch(GeneralAction.HideLoading());
                }
            });
        };
    };
}

export default ChecklistMiddleware;
